module.exports = __webpack_public_path__ + "static/hard-rock-lyrics-620d35890b0f2ec034dd9a318d047a59.gif";